import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import styles from './CciApps.module.css';
import { Row, Col, Card, Spin, Input, Table, Modal, Tooltip, Tag } from 'antd';
import { CloudDownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';
import { fetchJsData } from '../../../../api';
import { crawl } from '../../../../api/util';

const newCCi = [
    {
        title: 'App Name',
        dataIndex: 'current_name',
        key: 'current_name',
        fixed: 'left',
        sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
        responsive: ['sm'],
        width: '40%',
    },
    {
        title: 'Category Name',
        dataIndex: 'category_name',
        key: 'category_name',
        fixed: 'left',
        sorter: (a, b) => (a.category_name ? a.category_name.localeCompare(b.category_name) : 1),
        responsive: ['sm'],
        width: '40%',
    },
    {
        title: 'CCL',
        dataIndex: 'ccl',
        key: 'ccl',
        fixed: 'left',
        sorter: (a, b) => (a.ccl ? a.ccl.localeCompare(b.ccl) : 1),
        responsive: ['sm'],
        width: '20%',
    },
];

const chngCcl = [
    {
        title: 'App Name',
        dataIndex: 'current_name',
        key: 'current_name',
        fixed: 'left',
        sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
        responsive: ['sm'],
        width: '35%',
    },
    {
        title: 'Category Name',
        dataIndex: 'category_name',
        key: 'category_name',
        fixed: 'left',
        sorter: (a, b) => (a.category_name ? a.category_name.localeCompare(b.category_name) : 1),
        responsive: ['sm'],
        width: '35%',
    },
    {
        title: 'Old Ccl',
        dataIndex: 'oldccl',
        key: 'oldccl',
        fixed: 'left',
        sorter: (a, b) => (a.oldccl ? a.oldccl.localeCompare(b.oldccl) : 1),
        responsive: ['sm'],
        width: '15%',
    },
    {
        title: 'New Ccl',
        dataIndex: 'newccl',
        key: 'newccl',
        fixed: 'left',
        sorter: (a, b) => (a.newccl ? a.newccl.localeCompare(b.newccl) : 1),
        responsive: ['sm'],
        width: '15%',
    },
];

const newDomain = [
    {
        title: 'App Name',
        dataIndex: 'current_name',
        key: 'current_name',
        fixed: 'left',
        sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
        responsive: ['sm'],
        width: '15%',
    },
    {
        title: 'Category',
        dataIndex: 'category_name',
        key: 'category_name',
        fixed: 'left',
        sorter: (a, b) => (a.category_name ? a.category_name.localeCompare(b.category_name) : 1),
        responsive: ['sm'],
        width: '15%',
    },
    {
        title: 'Domain',
        dataIndex: 'domain_name',
        key: 'domain_name',
        fixed: 'left',
        sorter: (a, b) => (a.domain_name ? a.domain_name.localeCompare(b.domain_name) : 1),
        responsive: ['sm'],
        width: '15%',
    },
];

const updatedCat = [
    {
        title: 'App Name',
        dataIndex: 'current_name',
        key: 'current_name',
        fixed: 'left',
        sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
        responsive: ['sm'],
        width: '15%',
    },
    {
        title: 'Old Category',
        dataIndex: 'old_category',
        key: 'old_category',
        fixed: 'left',
        sorter: (a, b) => (a.old_category ? a.old_category.localeCompare(b.old_category) : 1),
        responsive: ['sm'],
        width: '15%',
    },
    {
        title: 'New Category',
        dataIndex: 'new_category',
        key: 'new_category',
        fixed: 'left',
        sorter: (a, b) => (a.new_category ? a.new_category.localeCompare(b.new_category) : 1),
        responsive: ['sm'],
        width: '15%',
    },
];

const appNameChnged = [
    {
        title: 'Old App Name',
        dataIndex: 'old_name',
        key: 'old_name',
        fixed: 'left',
        sorter: (a, b) => (a.old_name ? a.old_name.localeCompare(b.old_name) : 1),
        responsive: ['sm'],
        width: '15%',
    },
    {
        title: 'New App Name',
        dataIndex: 'new_name',
        key: 'new_name',
        fixed: 'left',
        sorter: (a, b) => (a.new_name ? a.new_name.localeCompare(b.new_name) : 1),
        responsive: ['sm'],
        width: '15%',
    },
];

export const OpenModal = (props) => {
    const [show, setShow] = useState(false);
    const [modData, setModData] = useState('');
    const [load, setLoad] = useState(true);
    const openModal = () => setShow(true);
    const closeModal = () => {
        setSearchVal('');
        setShow(false);
        props.setValue({ event: false, radioValue: '' });
    };
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);
    const [loading, setLoading] = useState(true);

    const latRel = props.rel;
    const curRel = parseInt(props.usrRel.split('snapshot_v')[1].split('_')[0]);
    const prevRel = curRel - 1;
    const diff = latRel - curRel;

    const fetchDwnData = async () => {
        try {
            setLoad(true);
            let data = [''];
            if (props.usrSel === 'new') {
                data = await fetchJsData({
                    type: 'fetch',
                    qry: 'fetNewCciApps',
                    firstVal: 'snapshot_v' + curRel + '_0_0',
                    secondVal: 'snapshot_v' + curRel + '_0_0',
                    thirdVal: 'snapshot_v' + curRel + '_0_0',
                    fourthVal: 'snapshot_v' + curRel + '_0_0',
                    fifthVal: 'snapshot_v' + prevRel + '_0_0',
                });
            }

            if (props.usrSel === 'changed') {
                data = await fetchJsData({
                    type: 'fetch',
                    qry: 'fetChngCclApps',
                    firstVal: 'snapshot_v' + curRel + '_0_0',
                    secondVal: 'snapshot_v' + curRel + '_0_0',
                    thirdVal: 'snapshot_v' + curRel + '_0_0',
                    fourthVal: 'snapshot_v' + curRel + '_0_0',
                    fifthVal: 'snapshot_v' + prevRel + '_0_0',
                    sixthVal: 'snapshot_v' + prevRel + '_0_0',
                    seventhVal: 'snapshot_v' + prevRel + '_0_0',
                    eigthVal: 'snapshot_v' + prevRel + '_0_0',
                });

                data['data'].map((x) => {
                    delete x.app1;
                    delete x.app2;
                });
            }

            if (props.usrSel === 'newdomain') {
                data = await fetchJsData({
                    type: 'fetch',
                    qry: 'fetNewDomain',
                    firstVal: 'snapshot_v' + curRel + '_0_0',
                    secondVal: 'snapshot_v' + curRel + '_0_0',
                    thirdVal: 'snapshot_v' + curRel + '_0_0',
                    fourthVal: 'snapshot_v' + curRel + '_0_0',
                    fifthVal: 'snapshot_v' + curRel + '_0_0',
                    sixthVal: 'snapshot_v' + prevRel + '_0_0',
                });
            }

            if (props.usrSel === 'updatedCat') {
                data = await fetchJsData({
                    type: 'fetch',
                    qry: 'fetCciAppCatUpdate',
                    firstVal: 'snapshot_v' + curRel + '_0_0',
                    secondVal: 'snapshot_v' + curRel + '_0_0',
                    thirdVal: 'snapshot_v' + curRel + '_0_0',
                    fourthVal: 'snapshot_v' + prevRel + '_0_0',
                    fifthVal: 'snapshot_v' + prevRel + '_0_0',
                });
            }

            if (props.usrSel === 'appNameChnged') {
                data = await fetchJsData({
                    type: 'fetch',
                    qry: 'fetCciChngAppName',
                    firstVal: 'snapshot_v' + curRel + '_0_0',
                    secondVal: 'snapshot_v' + prevRel + '_0_0',
                });
            }

            setModData(data['data']);
            return data;
        } catch (error) {
            console.error(error);
            return '';
        } finally {
            setLoad(false);
        }
    };

    useEffect(() => {
        setLoading(true);
        const fetchDatas = async () => {
            const { data: users } = await fetchDwnData();
            setOrigData(users);
            setFilteredData(users);
            const searchInd = users.map((user) => {
                const allValues = crawl(user);
                return { allValues: allValues.toString() };
            });
            setSearchIndex(searchInd);
            if (users) setLoading(false);
        };
        if (props.openModal === true) {
            fetchDatas();
        }
    }, [props.openModal]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) return origData[index];
                return null;
            });
            setFilteredData(
                reqData.filter((user) => {
                    if (user) return true;
                    return false;
                })
            );
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex, props.openModal]);

    // initial effect
    useEffect(() => {
        if (props.openModal === true && diff <= 1) {
            openModal();
        }
    }, [props.openModal]);

    const modalProp = {
        new: {
            title: 'New CCI Apps',
            width: '40%',
            fileName: 'newCci.csv',
            columns: newCCi,
            count: filteredData.length,
        },
        changed: {
            title: 'Changed CCL Apps',
            width: '50%',
            fileName: 'changedCclApps.csv',
            columns: chngCcl,
            count: filteredData.length,
        },
        newdomain: {
            title: 'New Domains',
            width: '70%',
            fileName: 'newDomain.csv',
            columns: newDomain,
            count: filteredData.reduce((a, b) => a + (b.domain_name ? b.domain_name.split(', ').length : 0), 0),
        },
        updatedCat: {
            title: 'Apps with Updated Category',
            width: '70%',
            fileName: 'updatedCat.csv',
            columns: updatedCat,
            count: filteredData.length,
        },
        appNameChnged: {
            title: 'Name Changed Apps',
            width: '50%',
            fileName: 'appNameChanged',
            columns: appNameChnged,
            count: filteredData.length,
        },
    };

    return (
        <Modal
            title={modalProp[props.usrSel] ? modalProp[props.usrSel].title : ''}
            visible={show}
            onOk={closeModal}
            onCancel={closeModal}
            width={modalProp[props.usrSel] ? modalProp[props.usrSel].width : ''}
        >
            {load ? (
                <div className={styles.spinner}>{<Spin size="small" />}</div>
            ) : (
                <>
                    <Card
                        title={
                            load ? (
                                <div>{<Spin size="small" />}</div>
                            ) : (
                                <Tag color="blue">
                                    {modalProp[props.usrSel] ? modalProp[props.usrSel].title : ''}:{' '}
                                    {modalProp[props.usrSel] ? modalProp[props.usrSel].count : ''}
                                </Tag>
                            )
                        }
                        size="small"
                        headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                        bordered={false}
                        extra={
                            <Row>
                                <Col span={21}>
                                    <Input
                                        value={searchVal}
                                        onChange={(e) => {
                                            setSearchVal(e.target.value);
                                        }}
                                        prefix={<SearchOutlined className="site-form-item-icon" />}
                                        placeholder="Crawl Search"
                                        allowClear
                                    />
                                </Col>
                                <Col span={1}></Col>
                                <Col className="gutter-row" span={2}>
                                    {' '}
                                    <div>
                                        {load ? (
                                            <div>{<Spin size="small" />}</div>
                                        ) : (
                                            <Tooltip placement="topRight" title="Download Report" arrowPointAtCenter>
                                                <CSVLink
                                                    filename={modalProp[props.usrSel] ? modalProp[props.usrSel].fileName : ''}
                                                    data={filteredData}
                                                    className="btn btn-primary"
                                                >
                                                    <CloudDownloadOutlined style={{ fontSize: '29px' }} />
                                                </CSVLink>
                                            </Tooltip>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        }
                    >
                        {load ? (
                            <div className={styles.spinner}>{<Spin size="small" />}</div>
                        ) : (
                            <Table
                                rowkey={filteredData.map((x, i) => i + 1)}
                                size="small"
                                bordered
                                scroll={{ x: 550, y: 900 }}
                                style={{ margin: '2px' }}
                                dataSource={filteredData}
                                loading={loading}
                                columns={modalProp[props.usrSel] ? modalProp[props.usrSel].columns : ''}
                                pagination={{
                                    pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                    defaultPageSize: ['10'],
                                    showSizeChanger: true,
                                }}
                            />
                        )}
                    </Card>
                </>
            )}
        </Modal>
    );
};
